import ClientAbstract from './ClientAbstract';
import { ApiLoadConsentResponse, ConsentSaveType } from '../types/common';

class ClientComs extends ClientAbstract {
  async getConsents(lifecycle: string) {
    const { spId, lcId } = this.getCustomerInfoFromConfigOrAuth();

    const path = lcId
      ? `/consent/sp/${spId}/customer/${lcId}`
      : `/consent/sp/${spId}/register`;

    const qs = {
      lifecycle,
      textformat: 'html',
      ...(lcId ? { ignoreNotFound: true } : {}),
      additionalInfo: true,
      pageformat: true,
    };

    return this.httpClient.get<ApiLoadConsentResponse>(path, qs);
  }

  async saveConsents(data: ConsentSaveType[]) {
    let channelMerge;

    const { lcId, spId, registerId } = this.getCustomerInfoFromConfigOrAuth();

    const {
      username = 'unknown',
    } = this.auth;

    const {
      references,
      comment,
      usertype,
      lifecycle,
      newcustomer,
      channel = 'Web',
      vonr = '',
      mode = '',
    } = this.config;

    const qs: Record<string, string | boolean> = {
      lifecycle,
    };

    if (newcustomer) {
      qs.isNewCustomer = true;
    }

    if (mode === 'merge') {
      qs.isMerge = true;
      channelMerge = 'Merge';
    }

    const headers: Record<string, string> = {
      'tef-coms-channel': channelMerge ?? channel,
      'tef-coms-username': vonr ? `${vonr} | ${username}` : username,
    };

    if (references) {
      headers['tef-coms-references'] = references;
    }
    if (comment) {
      headers['tef-coms-comment'] = comment;
    }
    if (usertype) {
      headers['tef-coms-usertype'] = usertype;
    }

    const path = lcId
      ? `/consent/sp/${spId}/customer/${lcId}`
      : `/consent/sp/${spId}/register/${registerId}`;

    return this.httpClient.post(path, data, qs, headers);
  }
}

export default ClientComs;
